/**
 * 课程内容
 * @description 课程内容
 * @author yly
 * @date 2023-9-12
 *  */
import React from 'react';
import { connect } from 'dva';
import { Spin, Card, Row, Col, Divider, Form, Input, Tabs } from 'antd'
import { WayForm } from './components/wayForm'
import { MessageForm } from './components/messageForm'
import { RecommendForm } from './components/recommendForm'
import { TaskForm } from './components/taskForm'

import { framework_tool, component_tool, utils_tool, } from '@/tool'
import { modelUtils } from "@/utils";
let { WizContainer, WizFileUpload } = framework_tool;
let {
  WizSelect,
  WizTreeSelectList, Wizmessage, WizForm, WizButton, WizModal, WizIcon, WizDropdown, WizMenu, WizTable, WizCustomSteps, WizAntdForm, WizBraftEditor

} = component_tool;
const WizItem = WizMenu.Item
const { TabPane } = Tabs;

class WizClassifySelect extends WizContainer {

  componentName = 'WizClassifySelect';

  constructor(props) {
    super(props);
    this.state = {
      stateSelects: props.initSelects || [],
      taskData: {},
      noticeData: {},
      featuredData: {},
      trainPathData: {},
      rowData: new Date().getTime(),
      programContent: {},
      selectedExamRows: [],//选择的课程考试
      selectedScheduleRows: [], //选择的课件
      checkList: [],
      activeKey: '1',
      resetNum:1,
    }
    this.defaultValue = props.value;
  }

  static defaultProps = {
    onChange: () => { },//点击modal 确定的回调方法
    value: [],//已选数据,
    modalProps: {},//modal的参数
    selectProps: {},//输入框的参数
    wizTreeSelectListProps: {},//WizTreeSelectList的参数
    apiProps: {},//调用分类接口的参数
    apiPath: 'questionType/nodeList',//api的redux动态模型的请求patg
    returnKey: false,//onChange返回数据是否需要key，默认返回对象
  };


  /**
   * 初始化时根据record判断是新增还是编辑
   */
  _componentDidMount() {
    const { value } = this.props;
    if (value) {
      if (value.featured) {
        this.setState({ featuredData: value.featured })
        this.submit(value.featured, 2, 'featured')
      }
      if (value.notice) {
        this.setState({ noticeData: value.notice })
        this.submit(value.notice, 2, 'notice')
      }
      if (value.trainPath) {
        this.setState({ trainPathData: value.trainPath })
        this.submit(value.trainPath, 2, 'way')
      }
      if (value.task) {
        this.setState({ taskData: value.task })
        this.submit(value.task, 2, 'task')
      }
    }
    if (this.props.onClearSupport) {
      this.props.onClearSupport(this._onClear.bind(this))
    }
  }
  getCheckList = (params = {}) => {
    this.doActions([
      {
        path: 'noticeTemplate/noticeInfoList',
        payload: {
          key: `noticeInfoList`,
          apiParams: { ...params }
        }
      }
    ])
  }
  propsAndStateOnChange = {
    notificationList: this._notificationListOver.bind(this),
    value: this._getValueOver.bind(this),
  }
  _getValueOver(nextProps, nextState) {
    const { value } = nextProps;
    if (value) {
      console.log(value, 'value889898')
      if (value.featured) {
        nextState.featuredData = value.featured
        this.submit(value.featured, 2, 'featured')
      }
      if (value.notice) {
        nextState.noticeData = value.notice
        this.submit(value.notice, 2, 'notice')
      }
      if (value.trainPath) {
        nextState.trainPathData = value.trainPath
        this.submit(value.trainPath, 2, 'way')
      }
      if (value.task) {
        nextState.taskData = value.task
        this.submit(value.task, 2, 'task')
      }

      return true;
    } else {
    }
    return false;
  }
   /**
   * 重置
   */
   _onClear = () => {
    let {resetNum}=this.state
    console.log(resetNum,'resetNumresetNum')

    this.setState({resetNum:resetNum+1})
    // let { taskData,
    // noticeData,
    // featuredData,
    // trainPathData} =this.state
    // console.log(this.wayRef,'this.wayRef')
    // this.wayRef && this.wayRef.resetContent && this.wayRef.resetContent(taskData || '')

    // console.log(this.defaultValue, 'this.defaultValue7777')
    // let value = this.defaultValue
    // if (value) {
    //   if (value.featured) {
    //     this.setState({ featuredData: value.featured })
    //     this.submit(value.featured, 2, 'featured')
    //   }
    //   if (value.notice) {
    //     this.setState({ noticeData: value.notice })
    //     this.submit(value.notice, 2, 'notice')
    //   }
    //   if (value.trainPath) {
    //     this.setState({ trainPathData: value.trainPath })
    //     this.submit(value.trainPath, 2, 'way')
    //   }
    //   if (value.task) {
    //     this.setState({ taskData: value.task })
    //     this.submit(value.task, 2, 'task')
    //   }
    // }
  }
  _notificationListOver(nextProps, nextState) {
    if (nextProps.notificationList.code == 1) {
      if (nextProps.notificationList.data) {
        console.log(nextProps.notificationList.data, 'nextProps.notificationList.data')
        nextState.checkList = nextProps.notificationList.data
      }
    } else {
      nextProps.notificationList.data = [];
    }
    return true;
  }
  formatContent = (content, tab) => {
    let { programContent } = this.state
    if (tab == 'way') {
      programContent.AideTrainPath = content
    } else if (tab == 'task') {
      programContent.AideTask = content
    } else if (tab == 'featured') {
      programContent.AideFeatured = content
    } else if (tab == 'notice') {
      programContent.AideNotice = content
    }
    console.log(content, 'content')
    return programContent
  }
  submit = (data, type, tab) => {
    let { onChange } = this.props
    console.log('提交  =====>', data)
    this.setState({ programContent: this.formatContent(data, tab) })
    if (type == 3) {
      this.setState({ scheduleModalVisible: false })
    }
    onChange && onChange(this.formatContent(data, tab))
  }
  cancel = () => {
    this.setState({ scheduleModalVisible: false })
  }
  changeTab = (key) => {
    if (key == '2') {
      this.getCheckList({ bizType: 0 })
    } else if (key == '4') {
      this.getCheckList({ bizType: 38 })
    }
    this.setState({ activeKey: key })
  }
  /**选择课件模态框 */
  scheduleListModal() {
    let { noticeTemplateLoading } = this.props

    const { taskData, noticeData, featuredData, trainPathData, addType, checkList, activeKey,resetNum } = this.state

    return (
      <WizModal
        visible={this.state.scheduleModalVisible}
        onCancel={() => this.setState({ scheduleModalVisible: false })}
        footer={null}
        style={{ minWidth: 1000 }}
        title={'辅助设置'}
        key={this.state.scheduleListModalKey}
      >
        <Spin spinning={noticeTemplateLoading}>
          <Tabs activeKey={activeKey} onChange={(key) => this.changeTab(key)}>
            <TabPane tab="路径设置" key="1">
              <WayForm data={trainPathData} submit={this.submit} cancel={this.cancel} resetNum={resetNum}/>
            </TabPane>
            <TabPane tab="消息通知" key="2">
              <MessageForm data={noticeData} submit={this.submit} cancel={this.cancel} checkList={checkList}  resetNum={resetNum}/>
            </TabPane>
            <TabPane tab="推荐设置" key="3">
              <RecommendForm data={featuredData} submit={this.submit} cancel={this.cancel}  resetNum={resetNum}/>
            </TabPane>
            <TabPane tab="任务设置" key="4">
              <TaskForm data={taskData} submit={this.submit} cancel={this.cancel} checkList={checkList}  resetNum={resetNum}/>
            </TabPane>
          </Tabs>
        </Spin>
      </WizModal>
    )
  }

  editRecord = (record) => {
    this.setState({ data: record, scheduleModalVisible: true, addType: 'edit' })
  }
  deleteRow = (record) => {
    let content = [...this.state.programContent]
    content = content.filter(x => x.orderNum != record.orderNum)
    this.setState({ programContent: content })
  }
  lookRecord = (record) => {
    record.isRead = true
    this.setState({ data: record, scheduleModalVisible: true })
  }
  openSetting = () => {
    this.setState({ scheduleModalVisible: true })
  }
  _render() {
    return (
      <>
        <WizButton onClick={() => this.openSetting()}>
          辅助设置
        </WizButton>

        {this.scheduleListModal()}
      </>)
  }
}

const mapStateToProps = (state, ownProps) => {
  const { noticeTemplate } = state;
  const { apiProps } = ownProps;

  const notificationList = modelUtils.getModelEntity(noticeTemplate, 'noticeInfoList');
  const load = modelUtils.getLoadingState(state, "noticeTemplate");

  return {
    notificationList,
    ...load
  }
};

const options = { withRef: true };
export default Form.create()(connect(mapStateToProps, null, null, options)(WizClassifySelect));

